import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, AlertTriangle, XCircle, Loader2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { adminGetIntegrations, adminSmtpTest, formatApiError } from "@/lib/api";

export const STATE_UI = {
  configured: { label: "Configurato", cls: "bg-emerald-500/10 text-emerald-300 border-emerald-500/20", Icon: CheckCircle2, icon: "text-emerald-400" },
  incomplete: { label: "Configurazione incompleta", cls: "bg-amber-500/10 text-amber-300 border-amber-500/20", Icon: AlertTriangle, icon: "text-amber-300" },
  missing: { label: "Credenziali mancanti", cls: "bg-rose-500/10 text-rose-300 border-rose-500/20", Icon: XCircle, icon: "text-rose-400" },
};

export function StateBadge({ state }) {
  const ui = STATE_UI[state] || STATE_UI.missing;
  return (
    <span className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border ${ui.cls}`} data-testid={`state-badge-${state}`}>
      {ui.label}
    </span>
  );
}

function IntegrationRow({ item, onTest, testing }) {
  const ui = STATE_UI[item.state] || STATE_UI.missing;
  return (
    <div className="nadia-card p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:justify-between" data-testid={`admin-integration-${item.id}`}>
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <ui.Icon size={16} className={ui.icon} />
          <span className="font-heading text-base font-semibold text-slate-100">{item.label}</span>
          <StateBadge state={item.state} />
        </div>
        <div className="text-xs text-slate-500 mt-1">
          {item.state === "configured"
            ? (item.detail || "Attiva e configurata")
            : <>Variabili da valorizzare nei Production Secrets: <span className="font-mono text-slate-400" data-testid={`admin-integration-${item.id}-missing`}>{item.missing_env.join(", ")}</span></>}
        </div>
      </div>
      {item.id === "smtp" && (
        <Button size="sm" variant="outline" onClick={onTest} disabled={testing || item.state !== "configured"} className="border-white/10 shrink-0" data-testid="admin-smtp-test">
          {testing ? <Loader2 size={13} className="animate-spin mr-1" /> : <Send size={13} className="mr-1" />} Invia email di prova
        </Button>
      )}
    </div>
  );
}

export function IntegrationsPanel() {
  const [data, setData] = useState(null);
  const [testing, setTesting] = useState(false);
  useEffect(() => { adminGetIntegrations().then(setData).catch(() => setData({ items: [] })); }, []);
  const test = async () => {
    setTesting(true);
    try { const r = await adminSmtpTest(); toast.success(`Email di prova inviata a ${r.to}`); }
    catch (e) { toast.error(formatApiError(e)); } finally { setTesting(false); }
  };
  if (!data) return <div className="text-sm text-slate-500">Caricamento…</div>;
  return (
    <div className="space-y-3" data-testid="admin-integrations-list">
      {data.items.map((it) => <IntegrationRow key={it.id} item={it} onTest={test} testing={testing} />)}
      <p className="text-[11px] text-slate-500">I valori dei secret non vengono mai mostrati: qui compaiono solo i nomi delle variabili e il loro stato.</p>
    </div>
  );
}
